import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    padding: 0px 25px 0px 25px;
`;

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const TextStyled = styled.div`
    font-size: 1.25rem;
    font-weight: 400;
    margin-bottom: 5px;
    font-family: 'Galmuri11';
`;